import { Suspense, lazy } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Flex, Text, VStack } from '@chakra-ui/react'

import { FeatureListWithOfferConfiguration } from '@/entities/feature'
import { ReservationButtonByOfferStatus } from '@/features/ReservationButtons'
import { useMobile } from '@/shared/lib/hooks/useBreakpoints'

import { useLocationSection } from '../../model/useLocationSection'
import { TabSection } from '../../types'

const MapInfo = lazy(() =>
	import('@wwt/widgets/map').then(mod => ({ default: mod.MapInfo }))
)

export const LocationSection = ({
	offer,
	onShowOfferConfiguration
}: TabSection) => {
	const { t } = useTranslation('room-page')
	const {
		locationFeatures,
		longitude,
		latitude,
		isOfferConfigurationDisabled
	} = useLocationSection(offer)
	const isMobile = useMobile()

	return (
		<VStack
			gap="2rem"
			alignItems="flex-start"
		>
			<Box
				w="100%"
				h="20.5rem"
				bg="gray.300"
				borderRadius="md"
			>
				<Suspense fallback={null}>
					<MapInfo
						longitude={longitude}
						latitude={latitude}
					/>
				</Suspense>
			</Box>

			{locationFeatures.length ? (
				<FeatureListWithOfferConfiguration
					classNames={{ base: 'ps-5 md:ps-0' }}
					onShowOfferConfiguration={onShowOfferConfiguration}
					features={locationFeatures}
					isDisabledOfferConfiguration={isOfferConfigurationDisabled}
				/>
			) : (
				<Text
					as="h2"
					textStyle={{ base: 'body-text-2', md: 'headline-4' }}
					alignSelf="baseline"
					ps={{ base: '1.25rem', md: '0' }}
				>
					{t('locationFeaturesNotFound')}
				</Text>
			)}

			{!isMobile && (
				<Flex
					justifyContent="flex-end"
					mt="5.5rem"
				>
					<ReservationButtonByOfferStatus
						className="w-[25.5rem]"
						offer={offer}
					/>
				</Flex>
			)}
		</VStack>
	)
}
